import { styled, Theme } from '@mui/material';

export const sxStyles = {
  mainTitle: {
    marginBottom: '2.5rem',
  },
  categoriesWrap: (theme: Theme) => ({
    '> :not(:last-of-type)': {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  }),
  categoryTitle: {
    marginTop: '1.5rem',
    marginBottom: '1rem',
    textTransform: 'uppercase',
  },
  categoryItemsWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1rem 5rem',
    marginBottom: '1.5rem',
  },
};

export const StyledSectionInner = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  width: '100%',
  padding: '2.5rem',
  marginTop: '1.5rem',
  boxShadow: '0px 5px 25px rgba(17, 77, 76, 0.1)',
  borderRadius: '0.5rem',
}));

export const StyledCategoryItem = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  maxWidth: '240px',
  width: '100%',

  '& > div:first-of-type': {
    marginRight: '0.75rem',
  },
}));
